
import { Options, Vue } from "vue-class-component";
import ListCourierPartner from "@/app/ui/views/cod-delivery/components/list-courier-partner-section.vue";

@Options({
  components: { ListCourierPartner },
})
export default class CodPicShuttle extends Vue {}
